import { AD, EP, GLOBAL_CONTEXT, USER_TYPE_COOKIE_NAME } from "mmbclient/Common/CommonVariable";
import { useContext } from "react";
import './ConsignmentDetail.css';
import DatePicker from "react-datepicker";
import CircularSpinner from "mmbclient/Components/CircularSpinner";
import { getCookie, formatDate, convertToTwoDecimelNumber } from "mmbclient/Common/CommonFunctions";
import AccountStatementController from "mmbclient/Reports/AccountStatementController";

export const AccountStatement = () => {

    let balTotal = 0, balanceFlag = false;

    const store = useContext(GLOBAL_CONTEXT);

    const { setPrecision, openingAmt, setOpeningAmt, closingAmt, setClosingAmt, totalCredit, setTotalCredit, totalDebit, setTotalDebit, startBal, setStartBal, searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, option, setOption, betterLoggerFunction, handleSearch, exportToCSV, exportToExcel, RenderPagination } = AccountStatementController(store);

    return (
        <>
            <div onMouseOver={betterLoggerFunction}>
                {loading && <CircularSpinner />}
                {/* Body Content */}
                <div className="container mt-2">
                    <div className="text-center">
                        <h1 style={{fontSize:'20px'}}>Account Statement</h1>
                    </div>
                    <hr class="my-2" />

                    <div className="row mb-2">
                        {
                            (getCookie(USER_TYPE_COOKIE_NAME) === AD  || getCookie(USER_TYPE_COOKIE_NAME) === EP) ?
                                <>
                                    <div className="col-md-3">
                                        <label className="form-label small-label">Client</label>
                                        <select
                                            className="form-select small-input"
                                            value={client}
                                            onChange={(e) => setClient(e.target.value)}
                                        >
                                            {clientOption.map((option, index) => (
                                                <option key={index} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </> : null
                        }
                        <div className="col-md-2">
                            <label className="form-label small-label">From Date</label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                className="form-control small-input"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="form-label small-label">To Date</label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control small-input"
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                        <div className="col-md-1 d-flex align-items-end">
                            <button className="btn btn-primary mt-2 small-input" onClick={
                                () => {
                                    setCurrentPage(1); // Reset to first page on search
                                    handleSearch();
                                }
                            }>
                                Search
                            </button>
                        </div>
                    </div>

                    {/* Export Buttons */}
                    <hr class="my-2" />
                    <div className="mb-3 d-flex align-items-center">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="form-control me-2 flex-grow-1 small-input"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1); // Reset to first page on search
                            }}
                        />
                        <div className="dropdown">
                            <button
                                className="btn btn-primary dropdown-toggle small-input"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Export
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                <li>
                                    <button className="dropdown-item small-input" onClick={exportToCSV}>
                                        Export to CSV
                                    </button>
                                </li>
                                <li>
                                    <button className="dropdown-item small-input" onClick={exportToExcel}>
                                        Export to Excel
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Labels for Opening and Closing Amount */}
                    <div className="row mb-2" >
                        <div className="col-md-6 small-label">
                            <strong>Opening Amount:</strong> {openingAmt}
                        </div>
                        <div className="col-md-6 text-end small-label">
                            <strong>Closing Amount:</strong> {closingAmt}
                        </div>
                    </div>
                    {/* Data Table */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped small-label">
                            <thead>
                                <tr>
                                    <th>SNo</th>
                                    {
                                        (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ? <>
                                            <th>Client</th>
                                        </> : null
                                    }
                                    <th>Entry No.</th>
                                    <th>Entry Type</th>
                                    <th>Entry Date</th>
                                    <th>Bank Detail</th>
                                    <th>Entry Mode</th>
                                    <th>Remarks</th>
                                    <th>Credit</th>
                                    <th>Debit</th>
                                    {/* <th>Balance</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                            {
                                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ? <>
                                                    <td>{item.client_name}</td>
                                                </> : null
                                            }
                                            <td>{item.entry_no}</td>
                                            <td>{item.entry_type}</td>
                                            <td>{formatDate(item.entry_date)}</td>
                                            <td>{item.bank_detail}</td>
                                            <td>{item.entry_mode}</td>
                                            <td>{item.remarks}</td>
                                            <td>{convertToTwoDecimelNumber(item.credit_amount)}</td>
                                            <td>{convertToTwoDecimelNumber(item.debit_amount)}</td>
                                            {/* <td>
                                                {(function () {
                                                    if (balanceFlag === false) {
                                                        balanceFlag = true;
                                                        if (startBal > 0) {
                                                            balTotal = parseFloat(startBal);
                                                        } else if (startBal < 0) {
                                                            balTotal = parseFloat(startBal);
                                                        } else {
                                                            balTotal = 0;
                                                        }
                                                    }

                                                    if (balTotal < 0) {
                                                        balTotal = parseFloat(balTotal) - parseFloat(item.credit_amount) + parseFloat(item.debit_amount);
                                                    } else if (balTotal > 0) {
                                                        balTotal = parseFloat(balTotal) - parseFloat(item.credit_amount) + parseFloat(item.debit_amount);
                                                    } else {
                                                        balTotal = - parseFloat(item.credit_amount) + parseFloat(item.debit_amount);
                                                    }
                                                    let temp = balTotal;
                                                    if (temp > 0) {
                                                        temp = convertToTwoDecimelNumber(Math.abs(setPrecision(temp))) + " Dr";
                                                        item.balance = temp;
                                                        return <>{temp}</>;
                                                    } else if (temp < 0) {
                                                        temp = convertToTwoDecimelNumber(Math.abs(setPrecision(temp))) + " Cr";
                                                        item.balance = temp;
                                                        return <>{temp}</>;
                                                    } else {
                                                        item.balance = temp;
                                                        return <>{convertToTwoDecimelNumber(temp)}</>;
                                                    }
                                                })()}
                                            </td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="15" className="text-center">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Labels for Credit and Debit before Pagination */}
                        <div className="row mt-4">
                            <div className="col-md-7">
                                {/* Empty first half */}
                            </div>
                            <div className="col-md-2 text-end small-label">
                                <strong>Credit:</strong> {convertToTwoDecimelNumber(totalCredit)}
                            </div>
                            <div className="col-md-2 text-end small-label">
                                <strong>Debit:</strong> {convertToTwoDecimelNumber(totalDebit)}
                            </div>
                            <div className="col-md-1">
                                {/* Empty last column */}
                            </div>
                        </div>



                        <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-center">
                                <RenderPagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
                            </ul>
                        </nav>
                    </div>
                </div>

                {/* Footer */}
                {/* <footer className="bg-light text-center py-3">
                <div className="container">
                    <span>© 2024 My Application. All Rights Reserved.</span>
                </div>
                </footer> */}
            </div >
        </>
    );

}